<div class="my-3 w-full text-center">Sorry! No offers to show.</div>
<img width="220" src="/assets/img/img-empty-state-offer.svg" alt="No Records!" />